'use client'

import { usePathname } from 'next/navigation'

import { CartDrawer } from '@src/components/CartDrawer/CartDrawer'
import { TopNavV5AccountPanel } from '@src/components/TopNavV5/TopNavV5AccountPanel/TopNavV5AccountPanel'
import { TopNavV5Provider } from '@src/components/TopNavV5/TopNavV5Context'

import { defaultTopNavV5Props } from './TopNavV5.defaults'
import { TopNavV5Desktop } from './TopNavV5Desktop/TopNavV5Desktop'
import { TopNavV5Mobile } from './TopNavV5Mobile/TopNavV5Mobile'
import { type TopNavV5Props } from './TopNavV5Props'

export const TopNavV5 = (props: TopNavV5Props = defaultTopNavV5Props) => {
  const pathname = usePathname()
  const isCartPage = pathname?.includes('/cart')

  return (
    <TopNavV5Provider topNavProps={props}>
      <TopNavV5Mobile />
      <TopNavV5Desktop />
      <TopNavV5AccountPanel />
      {!isCartPage ? <CartDrawer /> : null}
    </TopNavV5Provider>
  )
}
